import { DigitalCentersVMDTO } from 'src/app/shared/interfaces/digital-centers/digital-centers-vm-dto.interface';
import { LastStatusTransition } from './last-status-transition';

export class Scan {
  public id: number;
  public mailId?: number;
  public contactId?: number;
  public serviceProprietaireId?: number; // (nullable)
  public barCode?: string; // (nullable) ça sera le refExpediteur par défaut
  public description?: string;
  public creationDate: string; // DateTime
  public lastStatusTransitionId?: number;
  public lastStatusTransition: LastStatusTransition;
  public statusID: number;
  public exists = false;
  public pdfFile: {
    id: number;
    scanId: number;
    fileName?: string;
    extension?: string;
    type?: string;
    dateUpload: string; // ($date - time)
    numberOfPages?: number;
  };
  public miniature: {
    id: number;
    scanId: number;
    fileName?: string;
    extension?: string;
    type?: string;
    dateUpload: string; // ($date - time)
    numberOfPages?: number;
  };
  // file
  public guid: string;
  public centreNumerisation: DigitalCentersVMDTO;
  public centreNumerisationId: number;
  constructor() {
    if (this.lastStatusTransition) {
      this.statusID = this.lastStatusTransition.statusId;
    }
  }
}
